import { render, staticRenderFns } from "./xfconfig.vue?vue&type=template&id=2fe50ff4&scoped=true"
import script from "./xfconfig.vue?vue&type=script&lang=js"
export * from "./xfconfig.vue?vue&type=script&lang=js"
import style0 from "./xfconfig.vue?vue&type=style&index=0&id=2fe50ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe50ff4",
  null
  
)

export default component.exports